export const CONFIG = {
  game: {
    initialDragonHealth: {
      smallDragon: 10_000_000,
      bigDragon: 25_000_000_000,
      dummy: 1_000_000_000,
    },
    stunEffectTotalTickDuration: 20000,
    goldPerDamage: 0.1,
    damagePerClick: 1,
    manaDrain: 1,
    maxMana: 100,
    skipDialogs: false,
  },
  save: {
    skipSave: false,
    saveKey: import.meta.env.VITE_GAME_PREFIX + '_save',
    timestampKey: import.meta.env.VITE_GAME_PREFIX + '_timestamp',
  },
  items: {
    unlockAtFraction: 0.5,
  },
};

export const spritesheetMapping: Record<string, [number, number]> = {
  sword0: [0, 0], // Column x Row
  sword1: [1, 0],
  sword2: [2, 0],
  sword3: [3, 0],
  sword4: [4, 0],
  sword5: [5, 0],
  staff0: [0, 1],
  staff1: [1, 1],
  staff2: [2, 1],
  staff3: [3, 1],
  staff4: [4, 1],
  staff5: [5, 1],
  bow0: [0, 2],
  bow1: [1, 2],
  bow2: [2, 2],
  bow3: [3, 2],
  bow4: [4, 2],
  bow5: [5, 2],
  bow6: [6, 2],
  arrow1: [7, 2],
  arrow2: [8, 2],
  axe0: [0, 3],
  axe1: [1, 3],
  axe2: [2, 3],
  axe3: [3, 3],
  axe4: [4, 3],
  dagger0: [0, 4],
  dagger1: [1, 4],
  dagger2: [2, 4],
  dagger3: [3, 4],
  dagger4: [4, 4],
  dagger5: [5, 4],
  lute0: [0, 5],
  lute1: [1, 5],
  lute2: [2, 5],
  flute0: [3, 5],
  flute1: [4, 5],
  fork: [5, 5],
  armor0: [0, 7],
  armor1: [1, 7],
  armor2: [2, 7],
  armor3: [3, 7],
  lock: [7, 8],
  lockRed: [8, 8],
  coin: [0, 8],
  coinStack1: [1, 8],
  coinStack2: [2, 8],
  silverBar: [3, 8],
  goldNecklace: [4, 8],
  goldBar: [5, 8],
  lightning: [0, 9],
  cloud: [1, 9],
  snow: [5, 9],
  missile: [6, 9],
  bang0: [0, 10],
  bang1: [1, 10],
  bang2: [2, 10],
  bang3: [3, 10],
  bang4: [4, 10],
  bang5: [5, 10],
  dice1: [0, 11],
  dice2: [1, 11],
  dice3: [2, 11],
  dice4: [3, 11],
  dice5: [4, 11],
  dice6: [5, 11],
  random: [6, 11],
  clock: [7, 11],
  clockUp: [8, 11],
  clockDown: [9, 11],
  bubbleEmpty: [5, 12],
  hearts0: [0, 13],
  hearts1: [1, 13],
  hearts2: [2, 13],
  hearts3: [3, 13],
  hearts4: [4, 13],
  hearts5: [5, 13],
  hearts6: [6, 13],
  units0: [0, 14],
  units1: [1, 14],
  units2: [2, 14],
  units3: [3, 14],
  units4: [4, 14],
  unitsDouble: [5, 14],
  plus1: [0, 15],
  plus2: [1, 15],
  plus3: [2, 15],
  minus1: [3, 15],
  minus2: [4, 15],
  minus3: [5, 15],
  arrowUp1: [6, 15],
  arrowUp2: [7, 15],
  arrowDown1: [8, 15],
  arrowDown2: [9, 15],
  cursor1: [0, 16],
  cursor2: [1, 16],
  hand: [2, 16],
  devilHorns: [3, 16],
  pointer1: [4, 16],
  pointer2: [5, 16],
  offline: [6, 16],
  feather: [0, 17],
  bell: [2, 17],
  star: [3, 17],
  poison: [4, 17],
  trap: [5, 17],
  bomb: [6, 17],
  bird: [0, 18],
  aim: [1, 18],
  snake: [2, 18],
  warrior: [3, 18],
  wizard: [4, 18],
  elf: [5, 18],
  thief: [6, 18],
  bard: [7, 18],
  cleric: [8, 18],
  potionEmpty: [0, 19],
  potionHalf: [1, 19],
  potionFull: [2, 19],
  ear: [0, 20],
};

export const spritesheetConfig = {
  mapping: spritesheetMapping,
  source: 'ui/others/icons-spritesheet.png',
  numberOfColumns: 10,
  spriteSize: 38,
  spriteGap: 0,
  spriteOffset: 0,
};
